import React from "react";
import "./home.scss";
import ScrollToHashElement from "./ScrollToHashElement";
import Header from "./section/header/header";
import Comingsoon from "./section/comingsoon/comingsoon";
import Newlaunching from "./section/newlaunching/newlaunching";
import Produk from "./section/produk/produk";
import Buttoncta from "../../component/buttoncta/buttoncta";
import SecondHero from "../../component/secondhero/SecondHero";
import Whychoose from "./section/whychoose/whychoose";
import Tenant from "../../component/tenant/tenant";

const home = () => {
  return (
    <div className="home">
      <ScrollToHashElement />
      <Header />
      <Comingsoon />
      <Newlaunching />
      <Produk />
      <Buttoncta />
      <SecondHero />
      <Whychoose />
      <Tenant />
    </div>
  );
};

export default home;
